<template>
  <div v-rect-loading="loading" class="personal-interview">
    <div class="title">{{ $t(`${ i18nPrefix }.title.interview`) }}</div>
    <van-collapse v-model="activeNames">
      <van-collapse-item class="info" name="information" :border="false" :title="$t(`${i18nPrefix}.label.information`)">
        <div v-for="(info, index) in interviewInfoList" class="info-item" :key="index">
          <div class="label">{{ info.label }}</div>
          <div class="value">{{ info.value }}</div>
        </div>
      </van-collapse-item>
    </van-collapse>
    <div class="content">
      <div class="content-title">{{ interviewTimeLabel }}</div>
      <div class="interview-time">
        <template v-if="interviewStatus === INTERVIEW_STATUS.PENDING_CANDIDATE_SELECT_TIME">
          <div
            v-for="(time, index) in availableInterviewTimeList"
            class="interview-time-item"
            :class="selectedTime === time && 'is-selected'"
            :key="index"
            @click="handleSelectInterviewTime(time)"
          >
            <div class="date">{{ formatDate(time.startDate) }}</div>
            <div class="time-range">{{ formatDateTime(time.startDate, time.startTime, time.endTime) }}</div>
          </div>
        </template>
        <div v-if="isInterviewScheduled" class="interview-time-item is-selected">
          <div class="date">{{ formatDate(interviewedTime.startDate) }}</div>
          <div class="time-range">{{ formatDateTime(interviewedTime.startDate, interviewedTime.startTime, interviewedTime.endTime) }}</div>
        </div>
        <div v-else-if="interviewStatus === INTERVIEW_STATUS.RESCHEDULING_BY_CANDIDATE" class="suggest-new-time">{{ $t(`${i18nPrefix}.label.suggestedNewTime`) }}</div>
        <div v-else-if="isInterviewCanceled" class="canceled">{{ $t(`${i18nPrefix}.label.canceled`)}}</div>

      </div>
      <div v-if="!hiddenBtn" class="btn-group">
        <el-button v-if="showConfirmBtn" class="confirm-btn" type="primary" @click="handleConfirm">{{ $t('common.btn.confirm') }}</el-button>
        <div class="multiple-btn">
          <el-button class="cancel-btn common-btn" @click="handleCancelInterview">{{ $t('common.btn.cancel') }}</el-button>
          <el-button v-if="showSuggestBtn" class="suggest-btn common-btn" @click="handleSuggestTime">{{ $t(`${ i18nPrefix }.btn.suggestTime`) }}</el-button>
        </div>
      </div>
    </div>
    <MobileCommonDialog
      class="cancel-dialog"
      :show.sync="cancelDialog.show"
      :loading="cancelDialog.loading"
      @save="confirmCancelInterview"
    >
      <template #title>
        <div class="dialog-title">
          {{ $t(`${i18nPrefix}.label.cancelInterview`) }}
        </div>
      </template>
    </MobileCommonDialog>
    <MobileCommonDialog
      class="cancel-dialog"
      :show.sync="suggestDialog.show"
      :loading="suggestDialog.loading"
      @save="confirmSuggestInterview"
    >
      <template #title>
        <div class="dialog-title">
          {{ $t(`${i18nPrefix}.label.suggestInterview`) }}
        </div>
      </template>
    </MobileCommonDialog>
  </div>
</template>

<script>
import MobileCommonDialog from '@/components/dialog/mobileCommonDialog.vue'
import mixin from '../mixin'

export default {
  components: {
    MobileCommonDialog
  },
  mixins: [mixin],
  data () {
    return {
      activeNames: ['']
    }
  }
}
</script>

<style scoped lang="scss">
.personal-interview {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;

  .title {
    padding: 18px 0 20px 20px;
    font-weight: 600;
    font-size: 20px;
    color: #000000;
    line-height: 28px;
  }

  .van-collapse {
    .info {
      .info-title {
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        line-height: 22px;
      }

      .info-item {
        margin-top: 8px;

        .label {
          font-weight: 500;
          font-size: 12px;
          line-height: 16px;
          color: #999;
        }

        .value {
          margin-top: 4px;
          font-size: 14px;
          color: #000;
          line-height: 20px;
        }
      }

      ::v-deep {
        .van-cell {
          padding-left: 20px;
        }

        .van-collapse-item__content {
          padding: 0 20px 18px;
        }
      }
    }

    &::after {
      border-color: #e4f4fd;
    }

    ::v-deep {
      .van-cell__title {
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        line-height: initial;
      }
    }
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 10px 20px 30px;

    .content-title {
      font-weight: 500;
      font-size: 16px;
      color: #000000;
      line-height: 22px;
    }

    .interview-time {
      margin-top: 20px;
      min-height: 130px;

      .interview-time-item {
        height: 60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 2px;
        border: 1px solid rgba(0, 150, 204, 0.3);
        color: #0096cc;
        box-sizing: border-box;
        cursor: pointer;

        &.is-selected {
          background: rgba(0, 150, 204, 0.1);
          border-radius: 4px;
          border-width: 0;

          .date, .time-range {
            font-weight: 500;
          }
        }

        & + .interview-time-item {
          margin-top: 10px;
        }

        .date, .time-range {
          font-size: 14px;
          line-height: 20px;
        }
      }

      .suggest-new-time,
      .canceled {
        text-align: center;
        font-size: 14px;
        line-height: 20px;
        color: #666;
        padding-top: 50px;
      }
    }

    .btn-group {
      margin-top: auto;
      padding-top: 48px;

      .common-btn {
        width: 100%;
        height: 48px;
        border-radius: 4px;
        border: 1px solid #0096cc;
        color: #0096cc;

        &:hover {
          background: rgba(0, 150, 204, 0.1);
        }
      }

      .confirm-btn {
        display: block;
        width: 100%;
        height: 48px;
      }

      .multiple-btn {
        margin-top: 12px;
        display: flex;

        .common-btn {
          flex: 1;
        }
      }
    }
  }

  .cancel-dialog {
    ::v-deep {
      .dialog-content {
        .container-body {
          min-height: initial;
        }
      }
    }
  }
}
</style>
